
import { faCheck } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'StepsHorizontal',

  props: {
    steps: {
      type: Array,
      default: () => [
        {
          label: 'Profile details',
          status: 'current',
          to: '/auth/register'
        },
        {
          label: 'Company details',
          status: 'upcoming',
          to: '/auth/register/company'
        }
      ]
    }
  },

  data() {
    return {
      faCheck
    }
  }
}
